import React, { PureComponent } from 'react';
import { TextArea } from '@dbk/ui-forms';
import { createContainer } from '@dbk-legacy/muster/react';


class ChatTextInput extends PureComponent {

    state = {
        text: ''
    };

    change = (event) => {
        this.props.onTextKeyPress(event)

        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.setState({ text: '' });
        }
    }

    render() {    
        const { i18n: { messages } } = this.props;
  
        return (<TextArea
            className={ this.props.isAttachmentEnabled ? "text-message-attachment": "text-message"}
            placeholder={messages["app.chat.textplaceholder"]}
            spellCheck="false"
            size="small"
            maxLength={500}
            value={this.state.text}
            onKeyPress={this.change}
            onChange={event => {
                this.setState({ text: event.target.value })
            }} />)

    }
}

export default createContainer({
    $queries: {
      i18n: {
        messages: true,
      }
    }
  })(ChatTextInput);
  
